import React from 'react';
import { Egs } from '../../providers/egs/Egs';
import { ProviderNames } from '../../providers/ProviderEnum';
import { Steam } from '../../providers/steam/Steam';

interface Props {
  name: string;
  showLink?: boolean;
  showUnlink?: boolean;
}

export function ProviderComponent({ name, showLink, showUnlink }: Props): JSX.Element {
  switch (name) {
    case ProviderNames.STEAM:
      return <Steam showLink={showLink} showUnlink={showUnlink} />;
    case ProviderNames.EGS:
      return <Egs showLink={showLink} showUnlink={showUnlink} />;
    default:
      return null;
  }
}
